import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const BoostActions = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default BoostActions